/**
 * 读取浏览器中用于验票 / 带鉴权请求的 JWT：mslogin_token 与 token 可能并存且不一致，
 * 按 exp 取较新者，避免旧 mslogin_token 长期覆盖新 token。
 */
function decodeJwtExpMs(jwt: string): number | null {
  try {
    const parts = jwt.split('.');
    if (parts.length < 2) return null;
    let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - (b64.length % 4));
    const payload = JSON.parse(atob(b64 + pad)) as { exp?: number };
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function pickTokenFromStorage(): string | null {
  try {
    const ls = globalThis.localStorage;
    const ss = globalThis.sessionStorage;
    if (!ls) return null;
    const a = ls.getItem('mslogin_token') || ss?.getItem('mslogin_token') || null;
    const b = ls.getItem('token') || ss?.getItem('token') || null;
    if (!a && !b) return null;
    if (!a) return b;
    if (!b) return a;
    if (a === b) return a;
    const ea = decodeJwtExpMs(a);
    const eb = decodeJwtExpMs(b);
    if (ea != null && eb != null) return ea >= eb ? a : b;
    return b;
  } catch {
    return null;
  }
}

export function clearAllAuthTokens(): void {
  try {
    const ls = globalThis.localStorage;
    const ss = globalThis.sessionStorage;
    ls?.removeItem('token');
    ss?.removeItem('token');
    ls?.removeItem('mslogin_token');
    ss?.removeItem('mslogin_token');
  } catch {
    /* ignore */
  }
}
